module.exports = __webpack_public_path__ + "img/smile.0469271b.png";